// extracted by mini-css-extract-plugin
export default {"footerImage":"babylist-babes__footerImage__nK68P"};